import { css } from 'styled-components'

export const privacyPolicyModalStyled = css`
	width: 100%;
	.makeStyles-box-8 {
		overflow: hidden !important;
	}
	.wrap-policy {
		max-width: 600px;
		height: calc(100vh - 20px);
		.content {
			height: calc(100vh - 170px);
			overflow-y: auto;
		}
	}

	h3,
	h4 {
		color: ${({ theme }) => theme.colors.primary.main};
	}

	.button-wrap {
	}
`
